import axios from "axios"
import JSONbig from 'json-bigint'
import AppStateStore from "../stores/AppStateStore"
import { browserHistory } from "react-router"
import AuthenticationStore from "../stores/AuthenticationStore"
import strings from '../localization/strings'
import autobind from "class-autobind"
export default class AxiosInstance {
	public instance
	constructor() {
		autobind(this)
		this.instance = axios.create({
			baseURL: api_url(),
			timeout: 7200000,
			withCredentials: true,
			transformResponse: data => {
				try {
					return JSONbig.parse(data)
				}
				catch (error) {
					return error.text
				}
			}
		})

		this.instance.interceptors.response.use(
			res => res,
			err => {
				AppStateStore.setProgressSnackbarContent(null)
				AppStateStore.setTextProgressSnackbarContent(null)
				if (err.toJSON().message === "Network Error") {
					AppStateStore.setAlertDialogContent({
						title: strings.Network_Error,
						content: strings.Please_check_your_internet_status
					})
				}
				else if (err.response) {
					if (err.response.status > 400 && err.response.status < 404) {
						AuthenticationStore.logout()
						browserHistory.replace("/login")
					}

					err.response.status === 406 && err.response.data.message === AppStateStore.notTicksExistResponse &&
						AppStateStore.setAlertDialogContent({ content: strings.the_endpoint_has_not_ticks })

					err.response.status === 409 && err.response.data.message === AppStateStore.failedToCheckConcurrency &&
						AppStateStore.setAlertDialogContent({
							buttonTitle: strings.Refresh,
							content: strings.old_data_saving_error,
							handleCloseCallBack: () => location.reload()
						})
				}
				return Promise.reject(err)
			}
		)
	}
}

